import '../sass/main.scss';

import './anims.js';
import './header.js';
import './sensory-experience.js';
import './popup.js';
import './music-particles.js';
import { Icons } from './icons';
const addIcons = () => {
    // Insert icons into their respective section headings
    const musicIcon = document.querySelector('.icon.music-icon');
    const wineIcon = document.querySelector('.icon.wine-icon');
    const weedIcon = document.querySelector('.icon.weed-icon');
    
    if (musicIcon) {
        musicIcon.insertBefore(Icons.get('music'), musicIcon.firstChild);
    }
    if (wineIcon) {
        wineIcon.insertBefore(Icons.get('wine'), wineIcon.firstChild);
    }
    if (weedIcon) {
        weedIcon.insertBefore(Icons.get('weed'), weedIcon.firstChild);
    }
}

document.addEventListener('DOMContentLoaded', function() {
    addIcons();
})